export default [
    {
        name: '__slot:zen_report_publication_title',
        sortField: 'title',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'datePublishAt',
        sortField: 'datePublishAt',
        type: 'dateRange',
        useInFilter: true,
        callback: 'zenDatePublishAt',
    },
    {
        name: 'typeLabel',
        sortField: 'type',
        type: 'zenPublicationsTypes',
        defaultValue: () => [],
        useInFilter: true,
    },
    {
        name: 'countViews',
        sortField: 'countViews',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
    },
    {
        name: 'countViewsTillEnd',
        sortField: 'countViewsTillEnd',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
    },
    {
        name: 'countLikes',
        sortField: 'countLikes',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
    },
    {
        name: 'countComments',
        sortField: 'countComments',
        type: 'number',
        useInFilter: true,
        dataClass: 'ral',
        callback: 'zenCommentWrap',
    },
]
